import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { cookieUtils } from "@/utils/cookieUtils";
import { useAuth } from "./useAuth";
import { useFormsList } from "./useFormsList";

export const useAccountVerification = () => {
    const [searchParams] = useSearchParams();
    const urlToken = searchParams.get('token');
    const { token, setToken } = useAuth();

    const cookieToken = cookieUtils.getAuthToken();

    useEffect(() => {
        if (!token && (urlToken || cookieToken)) {
            const tokenToSet = urlToken || cookieToken;
            if (tokenToSet) {
                setToken(tokenToSet);

                if (urlToken) {
                    cookieUtils.setAuthToken(urlToken);
                }
            }
        }
    }, [token, urlToken, cookieToken, setToken]);

    const { formsData, isLoading, isError, mutate } = useFormsList();

    return {
        apiData: formsData,
        loading: isLoading,
        error: isError,
        mutate
    };
};
